import { useTranslation } from 'react-i18next';

import PieChartGif from '../../../../../../../assets/pie-chart.gif';
import { i18nNS } from '../../../../../i18n';
import TileIntroductionForm, { TileIntroductionFormProps } from '../../../../shared/TileIntroductionForm';
import TileIntroductionLayout from '../../../../shared/TileIntroductionLayout';
import useIntroduction, { UseIntroduction } from './vm';

export interface IntroductionProps
  extends Pick<TileIntroductionFormProps, 'className' | 'onNext'>,
    UseIntroduction {}

const Introduction = ({ className, onNext, ...vmProps }: IntroductionProps) => {
  const { t } = useTranslation([i18nNS.POLL]);

  useIntroduction(vmProps);

  return (
    <TileIntroductionForm className={className} onNext={onNext}>
      <TileIntroductionLayout
        imageSrc={PieChartGif}
        description={t(
          'create_a_rich_poll_question_using_images_math_expressions_and_multiple_options_students_select_one_of_the_options_and_the_results_show_up_as_a_pie_chart',
          { ns: i18nNS.POLL }
        )}
      />
    </TileIntroductionForm>
  );
};

export default Introduction;
